// Synthetic Status-filter value the backend merges into status_filter_options
// when maira_scheduling_status is on. It is not a disconnection reason.
const SCHEDULED_VIA_MAIRA_STATUS = 'scheduled_via_maira';

export {
  SCHEDULED_VIA_MAIRA_STATUS,
};
